import React, { Component } from 'react';
import styled from 'styled-components';

import { currentLanguage } from 'helpers';
import WP from 'WP';

import Sun from 'icons/SunIcon';
import NorthernLights from 'icons/NorthernLightsIcon';
import Snow from 'icons/SnowflakeIcon';

import Media from 'css/Media';

class SeasonFilters extends Component {

    constructor(props) {
        super(props);
        this.state = {
            seasons: [
                {
                    title: {
                        no: 'Vinter',
                        en: 'Winter',
                    },
                    season: 'winter'
                },
                {
                    title: {
                        no: 'Nordlys',
                        en: 'Northern lights',
                    },
                    season: 'northern_lights'
                },
                {
                    title: {
                        no: 'Sommer',
                        en: 'Summer',
                    },
                    season: 'summer'
                },
            ],
            active: null,
        };
    }

    componentDidMount() {
        this.handleSeasonOverride();
    }

    getIcon = season => {
        if(season === 'winter') {
            return <Snow />
        } else if(season === 'summer') {
            return <Sun />
        } else return <NorthernLights />
    }

    handleClick = (season, i) => {
        this.setState({active: i});
        this.props.handleSeasonFilter(season);
    }

    handleSeasonOverride = () => {
        const { seasons } = this.state;
        const { seasonOverride } = this.props;

        if(!seasonOverride.length) return null;

        let activeIndex = null;
        let activeSeason = 'all';

        for(let i = 0; i <= seasons.length; i++)
        {
            if(seasons[i] && seasons[i].season === seasonOverride)
            {
                activeIndex = i;
                activeSeason = seasons[i].season;
                break;
            }
        }

        this.handleClick(activeSeason, activeIndex);
    }

    render() {
        const { seasons, active } = this.state;

        return (
            <Wrapper>
                { seasons.length && seasons.map((item, i) =>
                    <StyledLi key={i} isActive={active === i} onClick={() => this.handleClick(item.season, i)}>
                        {this.getIcon(item.season)}
                        <span>{currentLanguage() === 'no' ? item.title.no : item.title.en}</span>
                    </StyledLi>
                )}
                <StyledLi isActive={active === null} onClick={() => this.handleClick('all', null)}>
                    <span>{WP.trans.all}</span>
                </StyledLi>
            </Wrapper>
        )
    }
    
}

export default SeasonFilters;

const Wrapper = styled.ul`
    display: flex;
    align-self: center;
    margin-bottom: ${props => props.theme.spacing.elementXS};

    ${Media.greaterThan('s')`
        margin-bottom: 0;
        justify-content: flex-end;
    `}
`

const StyledLi = styled.li`
    list-style-type: none;
    display: flex;
    align-items: center;
    color: ${props => props.isActive ? props.theme.colors.text : props.theme.colors.button};
    cursor: pointer;
    margin-right: ${props => props.theme.spacing.contentS};

    span, svg path {
        transition: all .2s ease;
    }
    
    svg {
        margin-right: ${props => props.theme.spacing.contentXS};
        
        path {
            fill: ${props => props.isActive ? props.theme.colors.text : props.theme.colors.button};
        }

        ${Media.greaterThan('s')`
            margin-right: ${props => props.theme.spacing.contentM};
        `}
    }

    span {
        display: block;
        ${props => props.theme.p}
        line-height: 27px;
    }

    &:hover {
        span {
            color: ${props => props.theme.colors.text};
        }

        svg {
            fill: ${props => props.theme.colors.button};
        }
    }

    ${Media.greaterThan('s')`
        margin-right: ${props => props.theme.spacing.contentXL};
    `}
`